<template>
	<div>
		<div class="zhangsheng_pingbic" v-if="is_pingbic"></div>
		<div class="zhangsheng_dialog" v-if="is_pingbic">
			<i class="el-icon-error" @click="click_pingbic_close"></i>
			<div class="titl">{{$t('招生咨询')}}</div>
			<div class="des">{{$t('请输入您的学生信息，我们的教师团队将尽快与您联系')}}</div>
			<div class="name on">{{$t('学生姓名')}}</div>
			<input type="text" class="text" v-model="form.name" :placeholder="$t('请输入学生姓名')"/>
			<div class="name on">{{$t('联系电话')}}</div>
			<input type="text" class="text" v-model="form.mobile" :placeholder="$t('请输入您的联系电话')"/>
			<div class="name">{{$t('基本情况')}}</div>
			<textarea class="text textarea" v-model="form.remark" :placeholder="$t('请输入学生基本情况')"></textarea>
			<div class="tijiao" @click="post_tel">{{$t('立即咨询')}}</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'team',
	props: {
		is_pingbic: {
			type: Boolean,
			default:false
		},
	},
	data(){
		return{
			form:{
				name:'',
				mobile:'',
				remark:'',
			}
		}
	},
	mounted(){

	},
	methods:{
		click_pingbic_close(){
			this.$emit('callback');
		},
		post_tel(){
			if(!this.form.name){
				this.$message.error(this.$t('请输入学生姓名'));
				return
			}
			if(!this.form.mobile){
				this.$message.error(this.$t('请输入手机号'));
				return
			}
			var datas={
				name:this.form.name,
				mobile:this.form.mobile,
				remark:this.form.remark,
				type:2,
				createtime:Math.round(new Date().getTime()/1000)
			}
			this.$post('website/ClientWebsite/add',datas).then((res) => {
				this.$message.success(this.$t('咨询信息已提交等待回复'));
				this.click_pingbic_close();
				var path = this.$route.path.replace('/', '');
				if(path!='zhaosheng'){
					this.router_url('/zhaosheng')
				}
			})
		}
	}
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/views/zhaoshengzixun.vue